import GenericVModel from '@components/mixins/genericVModel'

export default {
  name: 'EditBlockSwitch',
  mixins: [GenericVModel],
  props: {
    activeColor: {
      required: false,
      type: String,
      default: '#C8E85E',
    },
    inactiveColor: {
      required: false,
      type: String,
      default: '#7c7e80',
    },
  },
}
